import { useCallback } from "react";

import {
  use2FAState,
  useFormattedFirstFactor,
} from "Login/TwoFA/API/queryHooks";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import { useFirstFactorIcon } from "Login/TwoFA/stateHooks";

import AuthCodeInput from "../../AuthCodeInput";

const FirstFactorCode = () => {
  const {
    firstCode,
    setFirstCode: setFirstCodeRaw,
    onInputChange,
  } = useTwoFAContext();
  const [{ allowPasswordForFirstFactor, firstFactorType }] = use2FAState();
  const formattedFirstFactor = useFormattedFirstFactor();
  const firstFactorIcon = useFirstFactorIcon();

  const setCode = useCallback(
    (value) => {
      setFirstCodeRaw(value);
      if (typeof onInputChange === "function") onInputChange(value);
    },
    [onInputChange, setFirstCodeRaw]
  );

  return (
    <AuthCodeInput
      data-cy="TwoFA_FirstFactorCode"
      code={firstCode}
      setCode={setCode}
      allowPassword={allowPasswordForFirstFactor}
      factorDisplay={formattedFirstFactor}
      factorType={firstFactorType}
      factorIcon={firstFactorIcon}
    />
  );
};

export default FirstFactorCode;
